module.exports = __webpack_public_path__ + "img/yellow.842b25d4.svg";